module.exports = __webpack_public_path__ + "img/news1.5801c068.png";